import { useState } from "react";
import { Link } from "react-router-dom";
import { MdOutlineDirectionsWalk, MdOutlineDirectionsRun, MdDirectionsBike, MdFlight } from "react-icons/md";

import ProgressBar from "../../components/ProgressBar";
import Listable, { VIEW_TYPES } from "../../components/Listable";
import i18n from "../../lib/i18n";

function getPriorityBadge(priority) {
  switch (priority) {
    case 1: return <MdFlight />;
    case 2: return <MdDirectionsBike />;
    case 3: return <MdOutlineDirectionsRun />;
    default: return <MdOutlineDirectionsWalk />;
  }
}

export default function EpicsList(props) {
  const [epics, setEpics] = useState(props.epics);
  return (
    <div>
      <Listable title={i18n("epics.title")}
        views={{
          [VIEW_TYPES.GRID]: data => (
            <Link to={`${props.currentPath}/epic/${data.id}`} className="link-clean">
              <div className="flex-column p-md">
                <div className="flex-row flex-gap-sm">
                  <div className="centered">{getPriorityBadge(data.priority)}</div>
                  <h3>{data.name}</h3>
                </div>
                <div className="m-t-sm">
                  <span><ProgressBar percentage={data.progress * 100} /></span>
                </div>
                <div className="m-t-sm">
                  {i18n("epics.tags")}: {data.tags}
                </div>
              </div>
            </Link>
          ),
          [VIEW_TYPES.LIST]: data => (
            <Link to={`${props.currentPath}/epic/${data.id}`} className="link-clean">
              <div className="flex-row flex-between w-100pc p-md">
                <div className="flex-row flex-gap-sm">
                  <div className="centered">{getPriorityBadge(data.priority)}</div>
                  <h3>{data.name}</h3>
                </div>
                <div>
                  <ProgressBar percentage={data.progress * 100} />
                </div>
              </div>
              <div className="p-l-md p-b-md p-r-md">
                {i18n("epics.tags")}: {data.tags}
              </div>
            </Link>
          )
        }}
        listItems={epics}
      ></Listable>
    </div>
  )
}